import React, { Component, useState, useEffect, useCallback } from 'react';
import { IconButton, TooltipHost, useResponsiveMode, DetailsList, SelectionMode, ComboBox, Text } from '@fluentui/react';
import { authProvider } from '../authProvider';
import axios from 'axios';
const assignmentColumns = [
    { key: "NameColumn", name: "Name", minWidth: 100, maxWidth: 100, },
    { key: "TypeColumn", name: "Type", minWidth: 100, maxWidth: 100, },
    { key: "RemoveColumn", name: "", minWidth: 100, maxWidth: 100, }
];
const comboBoxStyles = {
    root: {
        maxWidth: '300px',
        display: 'inline-block'
    },
    callout: {
        maxHeight: '300px',
    },
    optionsContainerWrapper: {
        maxHeight: '300px',
    },
    optionsContainer: {
        maxHeight: '300px',
    },
};
const assignButtonStyles={
    root: {
        display: 'inline-block'
    }
}
const PermissionManager = () => {
    const rootUrl = window.location.protocol + '//' + window.location.host + '/';
    const [principals, setPrincipals] = useState([]);
    const [roles, setRoles] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [accessToken, setAccessToken] = useState("");
    const [rolePrincipalSelections, setRolePrincipalSelections] = useState({});

    const getRoleById = (roleId) => {
        if (roles.length == 0)
            return null;
        return roles.find(role => role.roleId == roleId);
    };
    const getPrincipalById = (id) => {
        if (principals.length == 0)
            return null;
        return principals.find(p => p.id == id);

    }
    const getRoleAssignments = roleId => {
        if (assignments.length == 0) {
            return [];
        }
        return assignments.filter(a => a.roleId == roleId);
    }
    const removeAssignment = useCallback((assignmentId, principalId, principalType) => {
        var headers = { 'Authorization': "Bearer " + accessToken };
        var url = rootUrl + "api/Admin/RemoveRoleAssigment?id=" + assignmentId +
            "&principalId=" + principalId +
            "&principalType=" + principalType
        axios.delete(url, { headers: headers }).then((res) => {
            if (res.data) {
                var asns = [...assignments];
                var idx = asns.findIndex((itm) => itm.id == assignmentId);
                asns.splice(idx, 1);
                setAssignments(asns);
            }
        })
    }, [assignments]);

    const getPrincipalOptions = useCallback(() => {
        return principals?.map(p => {
            return {
                key: p.id,
                text: `${p.displayName} (${p.type})`
            }
        })
    }, [principals]);
    const renderAssignmentColumn = useCallback((item, index, column) => {
        var principal = getPrincipalById(item.principalId);
        var role = getRoleById(item.roleId);
        switch (column.key) {
            case "NameColumn":
                return principal?.displayName;
            case "TypeColumn":
                return item.principalType;
            case "RemoveColumn":
                return <TooltipHost content={`Remove ${principal?.displayName} from ${role?.roleName} `}><IconButton iconProps={{ iconName: "Delete" }} onClick={() => { removeAssignment(item.id, item.principalId, item.principalType) }} /></TooltipHost>;

        }
    });
    const onSelectedPrincipalChange = useCallback((principalId, roleName) => {
        var selections = { ...rolePrincipalSelections };
        selections[roleName] = principalId;
        setRolePrincipalSelections(selections);
    }, [rolePrincipalSelections]);
    const assignToRole = useCallback((roleId) => {
        var role = getRoleById(roleId);
        var headers = { 'Authorization': "Bearer " + accessToken };
        var principalId = rolePrincipalSelections[role.roleName];

        var principal = getPrincipalById(principalId);
        var assignment = { roleId: roleId, principalId: principalId, principalType: principal.type }

        axios.post(rootUrl + "api/admin/AddRoleAssignment", assignment, { headers: headers }).then((res) => {
            if (res && res.data) {
                var asns = [...assignments, res.data];
                setAssignments(asns);
            }
        });
        var selections = { ...rolePrincipalSelections }
        selections[role.roleName] = null;
        setRolePrincipalSelections(selections);

    }, [rolePrincipalSelections, assignments])
    useEffect(() => {
        authProvider.getIdToken().then((result) => {
            console.log(result.idToken.claims.roles);
        })
        authProvider.getAccessToken().then((result) => {
            setAccessToken(result.accessToken);
            var headers = { 'Authorization': "Bearer " + result.accessToken };
            axios.get(rootUrl + "api/admin/GetRoles", { headers: headers }).then((res) => {
                setRoles(res.data);
            });
            axios.get(rootUrl + "api/admin/GetPrincipals", { headers: headers }).then((res) => {
                setPrincipals(res.data);
            });
            axios.get(rootUrl + "api/admin/GetRoleAssignments", { headers: headers }).then((res) => {
                setAssignments(res.data);
            });

        });

    }, []);

    return (<div>

        {roles.map((role) =>
            <div key={role.roleId}>
                <h2>{role.roleName}</h2>
                <DetailsList
                    items={getRoleAssignments(role.roleId)}
                    columns={assignmentColumns}
                    onRenderItemColumn={renderAssignmentColumn}
                    selectionMode={SelectionMode.none}
                />
                <Text variant={'xLarge'}>Assign User or Group to {role.roleName}</Text>
                <div style={{display: "flex", marginBottom: "30px"}}>
                    <ComboBox
                        allowFreeform={false}
                        autoComplete={'on'}
                        options={getPrincipalOptions()}
                        styles={comboBoxStyles}
                        selectedKey={rolePrincipalSelections[role.roleName]}
                        onChange={(event, option, index, value) => {
                            onSelectedPrincipalChange(option.key, role.roleName);
                        }}
                    />
                    <TooltipHost content="Assign to role">
                        <IconButton style={assignButtonStyles} iconProps={{ iconName: "Link" }}
                            onClick={() => assignToRole(role.roleId)}
                            disabled={!rolePrincipalSelections[role.roleName]} />
                    </TooltipHost>
                </div>
            </div>
        )}

    </div>);
}

export default PermissionManager;